/* Copyright (c) 2020-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Button, ModalConfirm } from "@nordcloud/gnui";
import { useDisclosure } from "~/hooks";

type Props = {
  onDelete: (data: { expression: string }) => void;
  disableDeleteModal: boolean;
};

export function ResourceGroupExpressionDelete({
  onDelete,
  disableDeleteModal,
}: Props) {
  const { isOpen, open, close } = useDisclosure();

  return (
    <>
      <Button
        aria-label="delete button"
        data-testid="delete button"
        icon="trash"
        severity="low"
        onClick={() =>
          disableDeleteModal ? onDelete({ expression: "" }) : open()
        }
      />
      <ModalConfirm
        onClose={close}
        isOpen={isOpen}
        confirm={() => onDelete({ expression: "" })}
        actionLabel="Delete"
        data-testid="modal-delete-expression"
        contentLabel={`Delete resource group expression`}
      >
        {`Are you sure you want to delete resource group expression?`}
      </ModalConfirm>
    </>
  );
}
